var _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommentUnreadicon = function SvgCommentUnreadicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#comment_unread_icon_svg__a)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 3.5,
    r: 3.5,
    fill: "#FF4848"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "comment_unread_icon_svg__b",
    width: 17,
    height: 17,
    x: 0,
    y: -1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M12 9a5 5 0 0 0 5-5v12H0V-1h12a5 5 0 0 0 0 10Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    mask: "url(#comment_unread_icon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.1 10.736h5.6a.4.4 0 0 0 .4-.4v-.8a.4.4 0 0 0-.4-.4H4.1a.4.4 0 0 0-.4.4v.8c0 .221.18.4.4.4ZM11.9 7.536H4.1a.4.4 0 0 1-.4-.4v-.8c0-.22.18-.4.4-.4h7.8c.221 0 .4.18.4.4v.8a.4.4 0 0 1-.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 0a8 8 0 0 0-8 8v8h8A8 8 0 1 0 8 0Zm0 1.6A6.4 6.4 0 0 0 1.6 8v6.4H8A6.4 6.4 0 0 0 8 1.6Z",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "comment_unread_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgCommentUnreadicon;